export const DELETE_BASIC_LOCATION_DATA = 'DELETE_BASIC_LOCATION_DATA'
export const DELETE_CHOOSE_LOCATION = 'DELETE_CHOOSE_LOCATION'

export const REQUEST_LOCATION = 'REQUEST_LOCATION'
export const FAILURE_LOCATION = 'FAILURE_LOCATION'
export const SUCCESS_LOCATION = 'SUCCESS_LOCATION'

export const SET_SEARCH_LOCATION = 'SET_SEARCH_LOCATION'
export const SET_CHOOSE_PROVINCE = 'SET_CHOOSE_PROVINCE'
export const SET_CHOOSE_CITY = 'SET_CHOOSE_CITY'